(function () {
    class MenuTabs extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.tabs = this.querySelectorAll('button[data-tab]');
            this.checkboxes = document.querySelectorAll('input[name="filter.p.m.custom.pets"]');
            this.initTabs();
            this.setupEventListeners();
            this.syncCheckboxWithLocalStorage();
        }

        // initialize the tabs based on localStorage
        initTabs() {
            let selectedPet = localStorage.getItem('pet');

            this.tabs.forEach((tab, index) => {
                const targetTab = tab.getAttribute('data-tab');
                if (selectedPet) {
                    if (selectedPet === targetTab) {
                        tab.classList.add('active');
                        tab.setAttribute('aria-selected', 'true');
                    } else {
                        tab.classList.remove('active');
                        tab.setAttribute('aria-selected', 'false');
                    }
                    this.updateSelection(selectedPet)
                } else {
                    // default to first tab if none stored
                    if (index === 0) {
                        tab.classList.add('active');
                        tab.setAttribute('aria-selected', 'true');
                        localStorage.setItem('pet', targetTab);
                    }
                }
            });
        }

        // sync checkbox UI with stored value
        syncCheckboxWithLocalStorage() {
            const selectedPet = localStorage.getItem('pet');
            if (!selectedPet) return;
            let url = new URL(location.href);
            url.searchParams.delete('filter.p.m.custom.pets')
            let matching = Array.from(this.checkboxes).find(checkbox => checkbox.value === selectedPet);
            if (matching) {
                url.searchParams.set('filter.p.m.custom.pets', matching.value)
            
                const interval = setInterval(() => {
                    if (typeof FacetFiltersForm !== 'undefined' && FacetFiltersForm?.renderPage) {
                        FacetFiltersForm.renderPage(url.searchParams, null, false);
                        clearInterval(interval);
                    }
                }, 100);
            }
        }

        setupEventListeners() {
            // tab click handler
            this.tabs.forEach((tab) => {
                tab.addEventListener('click', (e) => {
                    e.preventDefault();
                    const targetTab = tab.getAttribute('data-tab');
                    const targetHref = tab.getAttribute('data-href');
                    this.updateSelection(targetTab);
                    location.href = targetHref;
                });
            });

            // checkbox change handler
            this.checkboxes.forEach((checkbox) => {
                checkbox.addEventListener('change', (e) => {
                    if (checkbox.checked) {
                        const pet = checkbox.value;
                        this.updateSelection(pet);
                        // uncheck the other checkboxes
                        this.checkboxes.forEach((cb) => {
                            if (cb !== checkbox) cb.checked = false;
                        });
                    } else {
                        // if unchecked manually, clear selection
                        localStorage.removeItem('pet');
                    }
                });
            });
        }

        // unified update logic for tabs + checkboxes
        updateSelection(pet) {
            localStorage.setItem('pet', pet);
            this.tabs.forEach((t) => {
                const targetTab = t.getAttribute('data-tab');
                if (targetTab === pet) {
                    t.classList.add('active');
                    t.setAttribute('aria-selected', 'true');
                } else {
                    t.classList.remove('active');
                    t.setAttribute('aria-selected', 'false');
                }
            });
        }
    }

    customElements.define('menu-tabs', MenuTabs);
})();